require('./angular-animate');
module.exports = 'ngAnimate';



//////////////////
// WEBPACK FOOTER
// ./~/angular-animate/index.js
// module id = 243
// module chunks = 0